<template>
  <b-card no-body class="my-2">
    <b-card-header class="card-header-results border-0">
      <div class="card-header-result-name">
        <b-button-group size="sm" class="mr-3">
          <b-icon
          variant="primary"
          :icon="collapsed ? 'dash-square' : 'plus-square'"
          v-b-tooltip.hover :title="$gettext('Expand')"
          @click="toggleCollapse()"
          />
          <b-icon icon="info-square"  variant="info" @click="$emit('info')" class="mx-1" v-b-tooltip.hover :title="$gettext('View more')"/>
          <b-iconstack  variant="danger" @click="$emit('toggle')" v-b-tooltip.hover :title="$gettext('Select PDF')">
            <b-icon icon="square" stacked />
            <b-icon icon="check" v-if="selected" scale="0.7" stacked />
          </b-iconstack>
        </b-button-group>
        <span style="font-size:16px; text-align:centre;" @click="toggleCollapse()">
          <strong class="header-title">{{result.name}}</strong>
          <sup class="stars">
            <span v-for="star in result.stars" :key="star">
              <b-icon icon="star-fill" />
            </span>
          </sup>
        </span>
        <h6 class="text-info d-inline ml-2">{{result.extraStars}}</h6>
      </div>
      <div class="price-and-status">
        <span v-if="status =='AVL'" class="FCAVL">{{ status }}</span>
        <span v-if="status =='RQ'" class="RQNA">{{ status }}</span>
        <span v-if="status =='N/A'" class="RQNA">{{ status }}</span>
        <span class="ml-2">
          <span class="full-price" :class="(displayedMeal.discount) ? 'price-start' : ''" >from: {{ getFullPrice({ meal: displayedMeal, starRating: result.stars, fees }) }} {{ params.currency }}</span>
          <span v-if="displayedMeal.discount"  class="sale-price">sale: {{ getPrice({ meal: displayedMeal, starRating: result.stars, fees }) }} {{ params.currency }}</span>
        </span>
      </div>
    </b-card-header>
    <b-card-body v-if="collapsed">
      <b-row>
        <b-col md="3">
          <b-card no-body>
            <b-carousel
              id="carousel"
              controls
              indicators
              background="#FFF"
              v-if="result.images.length"
            >
              <b-carousel-slide v-for="(image,imageIndex) in result.images" :key="'image' + imageIndex">
                <template slot="img">
                  <img :src="image.url" class="img-fluid w-100 d-block carousel-img"/>
                </template>
              </b-carousel-slide>
            </b-carousel>
            <template v-else>
              <img v-if="result.image" :src="result.image" class="img-fluid" />
              <img v-else src="@/assets/images/backgrounds/default-image.jpg" class="img-fluid" />
            </template>
            <div class="d-flex align-items-center justify-content-center p-3 website"  v-if="result.url">
              <small>
                <a :href="result.url" target="_blank">{{ result.url }}</a>
              </small>
            </div>
          </b-card>
        </b-col>
        <b-col md="9">
          <p style="white-space: pre-line;">{{ result.description }}</p>
        </b-col>
      </b-row>
      <slot></slot>
      <Legend/>
    </b-card-body>
  </b-card>
</template>
<script>
import { getFullPrice, getPrice } from 'b2b-common/utils/hotel'
import Legend from './legend'

export default {
  name: 'SearchResult',
  props: {
    params: Object,
    result: Object,
    selected: Boolean,
    expanded: Boolean,
    displayedMeal: Object,
    fees: {
      type: Object,
      required: false,
      default: () => { return {} }
    }
  },
  components: {
    Legend
  },
  data () {
    return {
      collapsed: this.expanded
    }
  },
  methods: {
    toggleCollapse () {
      this.collapsed = !this.collapsed
    },
    getFullPrice,
    getPrice
  },
  computed: {
    status () {
      let isAvl = false
      let isNa = true

      const categoriesMap = data => {
        data.categories.map(cat => {
          if (cat.hotelIsAvailable && !cat.hotelIsBlackedOut) isAvl = true
          if (!cat.hotelIsBlackedOut) isNa = false
        })
      }

      if (this.result.packages) {
        this.result.packages.map(pack => {
          categoriesMap(pack)
        })
      } else {
        categoriesMap(this.result)
      }

      if (isAvl) return 'AVL'
      else if (isNa) return 'N/A'
      else return 'RQ'
    }
  }
}
</script>

<style lang="scss">
  .price-start {
    text-decoration: line-through;
    margin-right: 5px;
  }
</style>
